/** Zones de l'écran présentées par la modale « L'interface évolue ». */
export const UI_ZONES = [
  "header",
  "notes",
  "photo",
  "toolbar",
  "tabs",
  "selection",
] as const;

export type UiZone = (typeof UI_ZONES)[number];

/** Numéro affiché sur le schéma et dans la liste (1 à 6). */
export function zoneNumber(zone: UiZone): number {
  return UI_ZONES.indexOf(zone) + 1;
}
